import { Component, OnInit, Input } from '@angular/core';
import { CalendarOptions } from '@fullcalendar/core';
import { MenuItem, MessageService } from 'primeng/api';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import { ConfigService, XpressCenterService } from 'app/services';
import { Utils } from 'app/utils';
import { cl } from '@fullcalendar/core/internal-common';

@Component({
    selector: 'home-calendar',
    templateUrl: './home-calendar.component.html',
    styleUrls: ['./home-calendar.component.scss'],
    providers: [MessageService]
})
export class HomeCalendarComponent implements OnInit {
    @Input()
    public menuPermissionActive!: string;
    public breadcrumbs: MenuItem[] = [{ icon: 'icon_back_office' }, { label: 'Application' }, { label: 'Calendar' }];

    constructor(public configService: ConfigService,
        public xpressCenterService: XpressCenterService,
        public messageService: MessageService) { }

    private searchTimer: number = 0;

    public xpressCenters: any;
    public selectedCenters: any = [];
    public searchFilter: string = '';

    ngOnInit(): void {
        this.getXpressCenters();
        this.getRiderScheduleCalendar();
    }

    public scheduleCalendar: any;

    public calendarOptions: CalendarOptions = {
        headerToolbar: {
            start: 'title prev,next',
            center: '',
            end: 'today dayGridMonth,dayGridWeek,timeGridDay'
        },
        initialView: 'dayGridWeek',
        plugins: [dayGridPlugin, timeGridPlugin],
        height: 890,
        allDaySlot: false,
        slotEventOverlap: false,
        views: {
            dayGridWeek: {
                eventContent: (eventInfo) => ({
                    html: `<div class="flex flex-row"><div style="width: 50px; height: 50px; background-position: center center;
                background-size: cover; display: inline-block; font-weight: bold;border-radius:
                50%;border: 1px solid #004060; margin-right: 15px; background-image: url('${eventInfo.event.extendedProps['imageUrl']}')"></div>` +
                        '<div><div style="font-size: 16px; letter-spacing: -0.38px;opacity: 1; color: black; margin-bottom: 6px;">' + eventInfo.event.title +
                        '</div>' + '<div style="text-transform: lowercase">' + eventInfo.event.start?.toLocaleTimeString('en-US', {
                            hour: '2-digit', minute:
                                '2-digit'
                        }) + ' - ' + eventInfo.event.end?.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }) + '</div></div>'
                })
            }
        }
    };

    public getRiderScheduleCalendar() {
        const dto = {
            TimeZoneOffset: Utils.getTimezoneOffset(),
            XpressCenters: this.selectedCenters,
            SearchWord: this.searchFilter
        };

        this.xpressCenterService.getRiderScheduleCalendar(dto, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.scheduleCalendar = data.Items.map((x: any) => {
                    x.start = Utils.utcToLocalDate(x.StartSchedule);
                    x.end = Utils.utcToLocalDate(x.StartSchedule)?.setMilliseconds(1 * 60 * 60 * 1000);
                    x.extendedProps = { imageUrl: x.RiderImageUrl };
                    x.title = x.RiderName;
                    return x;
                });
                this.calendarOptions = { ... this.calendarOptions, ...{ events: this.scheduleCalendar } };
            });

    }

    public getXpressCenters() {
        const dto = {
            SearchName: '',
            Skip: 0,
            Take: 0,
            City: '',
            SortField: '',
            SortOrder: 0
        };
        this.xpressCenterService.getXpressCenters(dto, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.xpressCenters = data.XpressCenters;
                console.log(this.xpressCenters);
            });

    }
    public handleFilterChange(): void {
        console.log(this.selectedCenters);
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getRiderScheduleCalendar();
            this.searchTimer = 0;
        }, 1500);
    }
}
